import { DatePicker, Select } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { BsDownload } from "react-icons/bs";
import { Link } from "react-router-dom";
import {
	export_system_orders,
	get_auditory,
} from "../../../../api/endpoints/auditory";
import { get_clients_simplified } from "../../../../api/endpoints/clients";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../utils/notificationToast";
import Main from "../../../layout/main/Main";
import {
	AntdButton,
	AuditCard,
	ContentCard,
	FieldGroup,
	FieldLabel,
	FilterContainer,
	FilterGrid,
	Inner,
	PageTitle,
	PageWrapper,
	SectionTitle,
} from "./styles";

const { Option } = Select;

export default function Auditory() {
	const [selectedClient, setSelectedClient] = useState(null);
	const [selectedMonth, setSelectedMonth] = useState(null);
	const [selectedYear, setSelectedYear] = useState(null);
	const [loading, setLoading] = useState(false);
	const [isLoadingMonthly, setIsLoadingMonthly] = useState(false);
	const [isLoadingAnnual, setIsLoadingAnnual] = useState(false);
	const [clients, setClients] = useState([]);

	const fetchClients = async () => {
		const res = await get_clients_simplified("approved");
		setClients(res || []);
	};

	useEffect(() => {
		fetchClients();
	}, []);

	const handleSubmit = async () => {
		if (!selectedClient) {
			openNotificationWithIcon(
				TYPE.ERROR,
				"Falta elegir un cliente",
				"Elija un cliente para poder descargar la auditoría.",
			);
			return;
		}

		if (!selectedMonth) {
			openNotificationWithIcon(
				TYPE.ERROR,
				"Falta elegir un mes",
				"Elija un mes para poder descargar.",
			);
			return;
		}

		setIsLoadingMonthly(true);
		try {
			const data = {
				month: moment(selectedMonth).month() + 1,
				year: moment(selectedMonth).year(),
				client: selectedClient,
			};

			const res = await get_auditory(data.month, data.year, data.client);
			const href = URL.createObjectURL(res);
			const link = document.createElement("a");
			link.href = href;

			const fileName =
				"Auditory_" +
				"Month_" +
				data.month +
				"_Year_" +
				data.year +
				"_" +
				moment().format("DDMMYYYYhhmmss") +
				".xlsx";

			link.setAttribute("download", fileName);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			URL.revokeObjectURL(href);
		} catch (err) {
			console.log(err);
		} finally {
			setIsLoadingMonthly(false);
		}
	};

	const handleDownloadYear = async () => {
		if (!selectedClient) {
			openNotificationWithIcon(
				TYPE.ERROR,
				"Falta elegir un cliente",
				"Elija un cliente para poder descargar la auditoría anual.",
			);
			return;
		}

		if (!selectedYear) {
			openNotificationWithIcon(
				TYPE.ERROR,
				"Falta elegir un año",
				"Elija un año para poder descargar la auditoría anual.",
			);
			return;
		}

		setIsLoadingAnnual(true);
		try {
			const data = {
				month: "",
				year: moment(selectedYear).year(),
				client: selectedClient,
			};

			const res = await get_auditory(data.month, data.year, data.client);
			const href = URL.createObjectURL(res);
			const link = document.createElement("a");
			link.href = href;

			const fileName =
				"Auditory_" +
				"Year_" +
				data.year +
				"_" +
				moment().format("DDMMYYYYhhmmss") +
				".xlsx";

			link.setAttribute("download", fileName);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			URL.revokeObjectURL(href);
		} catch (err) {
			console.log(err);
		} finally {
			setIsLoadingAnnual(false);
		}
	};

	const handleDownloadOrders = async () => {
		setLoading(true);
		try {
			const res = await export_system_orders();
			const href = URL.createObjectURL(res);

			const link = document.createElement("a");
			link.href = href;

			const fileName =
				"OneTransfer_Orders_" + moment().format("YYYYMMDD") + ".xlsx";
			link.setAttribute("download", fileName);
			document.body.appendChild(link);
			link.click();

			document.body.removeChild(link);
			URL.revokeObjectURL(href);
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						<Link to="/">Home</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>Auditoria</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>

			<Main.Body>
				<PageWrapper>
					<ContentCard>
						<PageWrapper>
							<PageTitle>Gestión de Auditorías</PageTitle>
							<AntdButton
								onClick={handleDownloadOrders}
								style={{
									position: "absolute",
									width: "200px",
									fontWeight: "400",
									height: 35,
									right: "15%",
								}}
								disabled={loading}
							>
								<BsDownload />
								Descargar Ordenes
							</AntdButton>
						</PageWrapper>
						<Inner>
							<AuditCard>
								<SectionTitle>Auditoría Mensual</SectionTitle>
								<FilterGrid>
									<FieldGroup>
										<FieldLabel>Elegir Cliente</FieldLabel>
										<FilterContainer>
											<Select
												value={selectedClient}
												onChange={(value) => setSelectedClient(value)}
												placeholder="Selecciona un cliente"
												showSearch
												optionFilterProp="children"
											>
												{clients?.map((client) => (
													<Option key={client.id} value={client.id}>
														{client.name}
													</Option>
												))}
											</Select>
										</FilterContainer>
									</FieldGroup>

									<FieldGroup>
										<FieldLabel>Seleccionar Mes</FieldLabel>
										<FilterContainer>
											<DatePicker.MonthPicker
												value={selectedMonth}
												onChange={(value) => setSelectedMonth(value)}
												placeholder="Seleccionar mes"
												format="MMMM YYYY"
											/>
										</FilterContainer>
									</FieldGroup>
								</FilterGrid>

								<AntdButton onClick={handleSubmit} loading={isLoadingMonthly}>
									<BsDownload />
									Descargar Auditoría Mensual
								</AntdButton>
							</AuditCard>

							<AuditCard>
								<SectionTitle>Auditoría Anual</SectionTitle>

								<FilterGrid>
									<FieldGroup>
										<FieldLabel>Elegir Cliente</FieldLabel>
										<FilterContainer>
											<Select
												value={selectedClient}
												onChange={(value) => setSelectedClient(value)}
												placeholder="Selecciona un cliente"
												showSearch
												optionFilterProp="children"
											>
												{clients?.map((client) => (
													<Option key={client.id} value={client.id}>
														{client.name}
													</Option>
												))}
											</Select>
										</FilterContainer>
									</FieldGroup>

									<FieldGroup>
										<FieldLabel>Seleccionar Año</FieldLabel>
										<FilterContainer>
											<DatePicker.YearPicker
												value={selectedYear}
												onChange={(value) => setSelectedYear(value)}
												placeholder="Seleccionar año"
												format="YYYY"
											/>
										</FilterContainer>
									</FieldGroup>
								</FilterGrid>

								<AntdButton
									onClick={handleDownloadYear}
									loading={isLoadingAnnual}
								>
									<BsDownload />
									Descargar Auditoría Anual
								</AntdButton>
							</AuditCard>
						</Inner>
					</ContentCard>
				</PageWrapper>
			</Main.Body>
		</Main>
	);
}
